export default __webpack_public_path__ + "static/chainmonsters-706a5d648cf41567d37798f244648e2c.png";